import { type StorageKey } from '../../utils/storage'

export const STORAGE_KEYS = {
    // session storage
    hipo: {
        code: 'veri-hipo',
        version: 1
    },

    // local storage
    compra: {
        code: 'veri-compra',
        version: 1
    },
    portfolio: {
        code: 'veri-portfolio',
        version: 1
    },
    contrato: {
        code: 'veri-contrato',
        version: 1
    },
    irs: {
        code: 'veri-irs',
        version: 1
    },
    euribor: {
        code: 'veri-euribor',
        version: 1
    },
    sys: {
        code: 'veri-sys',
        version: 1
    }
} as const satisfies Record<string, StorageKey>
